declare global {
  interface Window {
    gtag?: (command: string, ...args: any[]) => void;
  }
}

const loadGtagScript = (measurementId: string) => {
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;

  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${measurementId}', { debug_mode: false });
  `;

  document.head.appendChild(script1);
  document.head.appendChild(script2);
};

export const initAnalytics = (measurementId: string) => {
  if (typeof window === 'undefined' || !measurementId) return;
  loadGtagScript(measurementId);
};

export const trackEvent = (eventName: string, eventData?: Record<string, any>) => {
  if (!window.gtag) {
    return;
  }
  window.gtag('event', eventName, eventData);
};
